import english from '../assets/languages/en.json';
import spanish from '../assets/languages/es.json';

export type Localization = typeof english;

export enum LanguageCode {
  English = 'en-US',
  Spanish = 'es',
}

export const LANGUAGE_HEADER = 'Accept-Language';

export const codeToLocalization = (code: LanguageCode): Localization => {
  switch (code) {
    case LanguageCode.English: {
      return english;
    }
    case LanguageCode.Spanish: {
      return spanish;
    }
    default: {
      return english;
    }
  }
};
